/* eslint-disable max-len */

export default {
  lang: 'German',
  homeScreen: {
    title: 'Die Inseln der Bahamas', // Product specific
    subTitle: 'Flieg davon',
    stayConnected: 'Bleib in Kontakt',
    comingSoon: 'Kommt bald',
    messages: 'Nachrichten',
  },
  notification: {
    newAndNow: 'Neu & Jetzt!',
    alert: 'Warnung',
    contest: 'Wettbewerb',
    message: 'Inhalt',
    events: 'Ereignis',
    news: 'Nachrichten',
    other: 'Benachrichtigung',
    welcome: 'Willkommen',
  },
  loginScreen: {
    title: 'Schulung für Reisefachleute und Programm zur Verkaufsförderung', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Willkommen beim',
      headerBottom: 'Bahamas-Spezialisten-Programm', // Product specific
    },
    version2: {
      homeTitle:
        'Schauen wir mal, ob wir in unserem System ein Profil für Sie finden können.',
      homeTitleSub:
        'Geben Sie die E-Mail-Adresse ein, die Sie normalerweise für die Anmeldung bei Schulungsprogrammen verwenden.',
      noAccount:
        'Kein Konto gefunden ({email}), bitte versuchen Sie es mit einer anderen E-Mail oder erstellen Sie jetzt ein Konto.',
      continueButton: 'Weiter',
      success:
        'Sie haben Ihr Konto erfolgreich aktualisiert! Sie werden in Kürze auf die Startseite weitergeleitet.',
      successNewAccount:
        'Um Ihre Anmeldung abzuschließen, erhalten Sie eine Bestätigungs-E-Mail, um Ihr Konto zu verifizieren.',
      loginButton: 'Anmeldung',
      matchFound:
        'Wir haben eine Übereinstimmung gefunden. Bitte geben Sie Ihr Passwort ein, um fortzufahren.',
      magicLink: 'Melden Sie sich über einen Link in Ihrer E-Mail an:',
      magicLinkButton: 'Magic Link anfordern',
      magicLinkTitle:
        'Lassen Sie sich einen direkten Link an Ihre E-Mail schicken, mit dem Sie sich sofort anmelden können.',
      otherEmailButton: 'Einreichen',
      title:
        'Bitte nehmen Sie sich einen Moment Zeit, um alle nachstehenden Informationen auszufüllen, da dadurch Ihr persönliches Profil und Ihre Kontaktinformationen erstellt werden.',
      titleIndustry:
        'Bitte nehmen Sie sich einen Moment Zeit, um alle nachstehenden Informationen auszufüllen, da dadurch Ihr persönliches Profil und Ihre Kontaktinformationen erstellt werden.',
      register: 'Ein Konto erstellen',
      agent: 'Reiseberater',
      visitor: 'Industrie Besucher',
      step1: 'Schritt 1: Art des Nutzers',
      step2: 'Schritt 2: Ein Konto erstellen',
      step3: 'Schritt 3: Erstellen Sie Ihr Profil',
      marketingOptIn:
        'Sind Sie sicher, dass Sie nicht daran interessiert sind, mit dem Travel Trade Team dieses Programms in Verbindung zu bleiben?',
      optIn: 'Ja, ich bin interessiert',
      optOut: 'Nicht Interessiert',
      step2Sub1: 'Erzählen Sie uns von sich selbst',
      step2Sub2: 'Erzählen Sie uns von Ihrem Unternehmen',
      privacyHead: 'KOMMUNIKATIONSPRÄFERENZEN',
      privacySub:
        'Kreuzen Sie die unten stehenden Kästchen an, um sicherzustellen, dass Sie wichtige Mitteilungen vom Reisebüroteam des Anbieters (Produktaktualisierungen und -ankündigungen, Prämien, Incentives, FAMs usw.) sowie Netzwerk- und Verkaufsförderungsinitiativen von TravPRO Mobile erhalten.',
      privacy:
        'Wir schützen Ihre Privatsphäre und verkaufen, missbrauchen oder betrügen niemals Ihr Vertrauen.',
      store:
        'Laden Sie dieses Programm ganz einfach in Ihrem App-Store herunter:',
      powered: 'ANGETRIEBEN DURCH',
      toastMessage: {
        forgotSuccess:
          'Wir haben Ihnen den Link zum Zurücksetzen Ihres Passworts per E-Mail geschickt! Sie werden in 10 Sekunden zur Login-Seite weitergeleitet.',
        emailNotExisting:
          'Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.',
        magicLinkMessage: 'Bitte warten Sie, wir melden Sie gerade an.',
        magicLinkError:
          'Wir konnten Ihr Konto nicht in unserer Datenbank finden. Bitte melden Sie sich manuell an. Sie werden in 10 Sekunden weitergeleitet.',
        magicLinkError1:
          'Wir konnten keinen gültigen Token finden, bitte melden Sie sich an oder fordern Sie einen neuen magischen Link an.Wenn dieses Problem weiterhin besteht, kontaktieren Sie uns bitte unter: info@travpromobile.com.',
        magicLinkError2:
          'Wir konnten Ihr Konto nicht in unserer Datenbank finden. Bitte melden Sie sich manuell an.Sie werden in 10 Sekunden weitergeleitet.',
        magicLinkSuccess:
          'Prüfen Sie Ihre E-Mail an {email}.Sie enthält einen magischen Link, mit dem du dich anmelden kannst.',
        magicLinkErrorWait:
          'Bitte warten Sie 5 Minuten zwischen den Anfragen nach magischen Links.',
        emailNotFoundError:
          'Die von Ihnen eingegebene E-Mail-Adresse kann in unseren Unterlagen nicht gefunden werden. Bitte prüfen Sie auf Schreibfehler oder erstellen Sie ein Konto.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode nicht gefunden, versuchen Sie es erneut',
        zipCodeOnlyNumbers: 'ZipCode kann nur Zahlen enthalten',
        password: 'Bitte geben Sie ein Passwort ein',
        passwordNotMatching:
          'Die von Ihnen eingegebenen Passwörter stimmen nicht überein',
        passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
        emailExists:
          'Diese E-Mail Adresse existiert bereits oder ist ungültig. Bitte versuchen Sie es mit einer anderen E-Mail-Adresse oder melden Sie sich bei Ihrem Konto an.',
        fillInAllFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
        fillInEmail: 'Bitte geben Sie Ihre E-Mail-Adresse an.',
        emailNotExisting:
          'Die von Ihnen eingegebene E-Mail-Adresse existiert nicht.',
      },
      fields: {
        forgotSubCopy:
          'Sie haben Ihr Passwort vergessen und möchten es ändern? ',
        forgotSubCopy2:
          'Möchten Sie das Passwort ganz umgehen? Wir schicken Ihnen eine E-Mail mit einem magischen Link, der Sie automatisch beim Programm anmeldet.',
        city: 'Stadt',
        companyName: 'Name des Unternehmens',
        role: 'Ihre Rolle',
        description:
          'Was beschreibt das Geschäft Ihres Unternehmens am besten?',
        country: 'Land',
        password: 'Passwort',
        passwordRegister: 'Passwort wählen (mindestens 8 Zeichen)',
        passwordConfirm: 'Bestätigen Sie Ihr Passwort',
        firstName: 'Vorname (gegeben)',
        lastName: 'Nachname (Familie)',
        agency: 'Name Ihrer Agentur',
        title: 'Ihre Rolle (Wählen Sie eine aus)',
        company: 'Name des Unternehmens',
        select: 'Wählen Sie unten eine Option',
        state: 'Staat',
        province: 'Bundesland/Region/Staat',
        zipCode: 'Postleitzahl',
        postalCode: 'Postleitzahl',
        affiliate: 'Welcher Gruppe gehören Sie in erster Linie an?',
        hostAgency: 'Ihre Aufnahmeagentur?',
        executive: 'Exekutive',
        management: 'Verwaltung',
        marketing: 'Marketing',
        sales: 'Vertrieb',
        coordinator: 'Koordinator',
        opt: 'Bleiben Sie mit dem Team dieses Programms in Verbindung und erhalten Sie aktuelle Informationen.',
        optMarketing:
          'Bleiben Sie mit TravPRO in Verbindung, wenn es um ähnliche Programme und Veranstaltungen geht.',
        retail: 'Einzelhandelsgeschäft Front',
        home: 'Home-Based Agent',
        independent: 'Unabhängiger Auftragnehmer',
        host: 'Gastgeber-Agentur',
        call: 'Call Center oder Web-basierte Agentur',
        other: 'Andere',
        describes:
          'Was beschreibt Sie und die Tätigkeit Ihrer Agentur am besten?',
      },
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Unterwegs lernen, werben und verkaufen',
      1: 'Multimediales Training für alle Geräte',
      2: 'Zertifikat zum Abschluss',
      3: 'Fertige Verkaufspräsentationen',
      4: 'Hochwirksame Werbematerialien',
      5: 'Insider-Tipps und Werbeaktionen',
      6: 'Produktverzeichnis in Echtzeit',
      7: 'Rechtzeitige Nachrichten und Updates',
    },
    forgot: 'Passwort zurücksetzen',
    forgotCopylong:
      'Haben Sie Ihr Passwort vergessen? Klicken Sie auf die Schaltfläche unten und wir senden Ihnen eine E-Mail, um Ihr Passwort zurückzusetzen.',
    forgotHeader:
      'Bitte geben Sie die E-Mail-Adresse ein, die Sie bei der Registrierung für Ihr Bahamas-Spezialisten-Konto verwendet haben. Wir senden Ihnen eine E-Mail, mit der Sie Ihr Passwort zurücksetzen können.',
    emailPrompt:
      'Bitte geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein, um zu bestätigen, dass Sie ein Reiseprofi sind.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'Wenn Sie fortfahren, erklären Sie sich mit unserer ',
      privacyPolicy: 'Datenschutzrichtlinie',
      and: ' und ',
      termsConditions: 'Bedingungen und Konditionen',
    },
    fields: {
      forgot: 'Passwort zurücksetzen',
      forgotCopylong:
        'Haben Sie Ihr Passwort vergessen? Klicken Sie auf die Schaltfläche unten und wir senden Ihnen eine E-Mail, um Ihr Passwort zurückzusetzen.',
      agency: 'Agentur',
      email: 'E-Mail',
      password: 'Kennwort',
      passwordConfirm: 'Bestätigen Sie Ihr Passwort',
      firstName: 'Vorname',
      lastName: 'Nachname',
      agencyName: 'Name der Agentur',
      stateProvince: 'Staat/Provinz',
      required: 'Erforderlich',
      invalidEmail: 'Ungültige E-Mail-Adresse',
      opt: 'Bleiben Sie mit uns in Kontakt! Ja, ich möchte Informationen von den Bahamas erhalten, die mich über Neuigkeiten, Veranstaltungen, Incentives, FAMs und mehr auf dem Laufenden halten!',
    },
    noAgent: {
      noAgentButton: 'Ich bin kein Berater',
      title: 'Vielen Dank für Ihr Interesse an den Bahamas.', // Product specific
      messageWeb:
        'Der Inhalt dieser Website ist ausschließlich für Reiseprofis bestimmt. \nUm mehr über die Bahamas zu erfahren, besuchen Sie bitte diese Seite: ', // Product specific
      messageMobile:
        'Einige Inhalte auf dieser App sind ausschließlich für Reiseprofis bestimmt. Sie können sich jedoch gerne eine Vorschau auf das Angebot dieser App ansehen, indem Sie auf "Weiter" klicken.', // Product specific
      continue: 'Weiter',
      visitWebsite: 'Website besuchen',
    },
    newUser: 'Neuer Benutzer',
    register: 'Registrieren',
    registered: 'Diese E-Mail ist bereits registriert',
  },
  welcomeScreen: {
    title: 'Willkommen bei dem\nBahamas Specialist Sales Companion', // Product specific
    helloUser: 'Hallo {{name}}',
    hello: 'Hallo,',
    fromAgency: 'von {{agency}}',
    notUser: 'Nicht {{name}}?',
    introOnline:
      'Schulen Sie sich sofort online oder laden Sie den Inhalt herunter, so dass er immer für die Offline-Nutzung verfügbar ist!',
    introOffline:
      'Sie haben bereits die neueste Version vorinstalliert. Beginnen Sie jederzeit und überall mit der Schulung oder dem Verkauf!',
    startTraining: 'Lernen beginnen',
    continueTraining: 'Weiter lernen',
    graduated: 'Herzlichen Glückwunsch!',
    downloader: {
      preload: 'Vorladen',
      stop: 'stoppen',
      init: 'Initialisierung...',
      lastUpdate: 'Letzte Aktualisierung: ',
    },
  },
  trainingScreens: {
    review: 'Überprüfung',
    start: 'Start',
    continue: 'Weiter',
    restart: 'Neustart',
    durationInMinutes: '{number} Minuten',
    percentageComplete: '{number} abgeschlossen',
    unlock:
      'Schalten Sie dieses Kapitel frei, indem Sie das Trainings-Kapitel {number} abschließen.',
    unlockSubtitle:
      'Schalten Sie weitere Kapitel frei, indem Sie das Trainingskapitel abschließen.',
    allUnlocked: 'Sie haben alle Kapitel freigeschaltet!',
    certificate: 'Zertifikat',
    courseComplete: 'Weiter',
    endReached: 'Sie haben das Ende erreicht',
    retainEnd:
      'Verwenden Sie die obere Leiste, um in diesem Kapitel zu navigieren, oder drücken Sie die Zurück-Taste, um zur Übersicht zurückzukehren.',
    watchListenRead: 'Anschauen, anhören & mehr lesen',
    trouble:
      'Es sieht so aus, als ob Sie Probleme haben. Bitte lesen Sie den Inhalt der vorherigen Seite(n) noch einmal und versuchen Sie es erneut.',
    confirm: 'Bestätigen Sie Ihre Antwort',
    choose: 'Bitte wählen Sie eine Antwort',
    skip: 'Zurück >',
    viewAllTitle: 'Schulungs-Tipp',
    viewAll:
      'Um zur nächsten Seite zu gelangen, klicken Sie bitte auf die Symbole, um die zusätzlichen Inhalte anzuzeigen. Videos, Karten und andere hilfreiche Informationen wurden bereitgestellt, um Ihr Training zu verbessern und sicherzustellen, dass Sie den PRO-Status erreichen.',
    fillBlanks: 'Füllen Sie die Lücke(n) aus:',
    next: 'Nächste Frage',
    retry: 'Erneut versuchen',
    fastTrackText: {
      success:
        'Glückwunsch, Sie haben den Fast-Track-Kurs bestanden und den Rest der Ausbildung freigeschaltet!',
      failed:
        'Wenn Sie den Fast-Track-Kurs nicht bestanden haben, können Sie Ihr Training fortsetzen, um Ihr Diplom zu erwerben!',
    },
    fastTrack: 'Werden Sie ein ...',
    fastTrackExplanation: '...',
    fastTrackButton: 'Klicken Sie hier, um fortzufahren...',
    grading: 'Ihre Abschlussnote beträgt: {grade}%',
  },
  nav: {
    home: 'Startseite',
    train: 'Schulung',
    learn: 'Schulung',
    retain: 'Beibehalten',
    directory: 'Verzeichnis',
    showcases: 'Präsentationen',
    promote: 'Werbung',
    sell: 'Verkaufen',
    info: 'Informationen',
    rewards: 'Belohnungen',
    media: 'Medien',
    favorites: 'Favoriten',
    contact: 'Kontakt',
    reportCard: 'Diplom anzeigen',
    accountSettings: 'Kontoeinstellungen',
    messages: 'Nachrichten',
    search: 'Suche',
  },
  directory: {
    view: 'Jetzt anzeigen >',
    reset: 'Filter zurücksetzen >',
    results: 'Anzahl der Ergebnisse',
    acco: 'Nach Unterkunftstyp filtern',
    price: 'Nach Preis filtern',
    island: 'Nach Insel filtern',
    additional: 'Zusätzliche Filter:',
    accessibleproperty: 'Barrierefreie Unterkunft',
    beachfront: 'Direkt am Strand',
    casino: 'Casino',
    divecenter: 'Tauchcenter',
    fishinglodge: 'Fischerhütte',
    golf: 'Golf',
    marina: 'Jachthafen',
    selfcatering: 'Selbstversorgung',
    waterfront: 'Am Wasser',
    noResults:
      'Keine Ergebnisse gefunden. Bitte versuchen Sie es mit einer anderen Suche.',
    search: 'Nach Eintrag suchen...',
    back: 'Zurück',
  },
  contentHeaders: {
    train: 'Schulung',
    retain: 'Beibehalten',
    subapps: 'Bahamas Specialist Partner-Module',
    maintrainings: 'DIE GRUNDLAGE',
    subtrainings: 'MODULE ZUR SPEZIALISIERUNG',
  },
  pageDescriptions: {
    train:
      'Bilden Sie sich weiter, engagieren Sie sich und werden Sie zum Experten.',
    retain:
      'Ihre Ressource zum Beibehalten Ihres Fachwissens und zur Unterstützung Ihrer Verkaufsbemühungen. Nutzen Sie diesen Bereich, um eine Produktfrage kompetent zu beantworten oder sogar eine spontane Verkaufspräsentation zu erstellen - jederzeit, überall und auf jedem Gerät.',
    promote: 'Beginnen Sie das Gespräch mit Ihren Kunden und Interessenten.',
    sell: 'Beantworten Sie Kundenfragen und schließen Sie den Verkauf ab.',
    favorites: 'Schauen Sie sich Ihre persönlich favorisierten Inhalte an.',
    search: 'Durchsuchen Sie alle Inhalte.',
    subapps: '',
    maintrainings:
      'Schließen Sie diese wesentlichen Module ab, um Ihr Diplom zu erhalten.',
    subtrainings:
      'Verbessern Sie Ihre Kenntnisse und verdienen Sie für jedes der unten aufgeführten Module ein Abzeichen.',
  },
  general: {
    chapterTitle: 'Kapitel ',
    next: 'Weiter',
    yes: 'Ja',
    no: 'Nein',
    previous: 'Zurück',
    submit: 'Senden',
    back: 'Zurück',
    close: 'Schließen',
    page: 'Seite',
    search: 'Suche',
    showcase: 'Präsentationen',
    logIn: 'Anmelden',
    logOut: 'Abmelden',
    viewItem: '{type} anzeigen',
    imageNotFound: 'Bild nicht gefunden',
    noResultsFor: 'Keine Ergebnisse gefunden für: {{query}}',
    noFavorites: 'Sie haben noch keine Favoriten.',
    noMessages: 'Sie haben noch keine Nachrichten erhalten!',
    resultsFor: 'Ergebnisse für: {{query}}',
    showAll: 'Alle anzeigen',
    connectionError: 'Verbindungsfehler',
    alreadyExists: 'Bereits vorhanden',
    pageNotFound: '404 Seite nicht gefunden!',
    oops: 'Ups...',
    overview: 'Zurück zur Übersicht',
    complete: 'Fortsetzen',
    courseComplete: 'Kurs abgeschlossen!',
    chapterComplete: 'Kapitel abgeschlossen!',
    message: '{count} Nachricht',
    messagePlural: '{count} Nachrichten',
  },
  itemTypes: {
    image: 'Bild',
    brochure: 'Sammlung',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Sammlung',
  },
  questions: {
    dials: 'Drehen Sie die Wählscheiben, um die Antwort anzupassen',
    fitb: 'Füllen Sie die Lücke(n) aus',
    flip: 'Ändern Sie die Zahl, um die Antwort anzupassen',
    multipleChoice: 'Wählen Sie die richtige(n) Antwort(en)',
    slider: 'Wählen Sie die richtige Antwort mit dem Schieberegler',
    map: 'Beantworten Sie die Frage, indem Sie auf die richtige Position auf der Karte tippen',
    dropdown: 'Wählen Sie...',
    true: 'Richtig',
    false: 'Falsch',
  },
  reportCard: {
    download: 'Herunterladen',
    email: 'Per E-Mail senden',
    print: 'Drucken',
  },
  cookies: {
    consent: 'AKZEPTIEREN',
    optout: 'Abmelden',
    settings: 'Datenschutzeinstellungen',
    message:
      'Sie haben uns noch nichts über Ihre Datenschutzpräferenzen mitgeteilt! Das ist in Ordnung, aber wir möchten Ihnen die beste Erfahrung mit dem Sales Companion bieten.',
    disabled:
      'Es scheint, als hätten Sie die Verwendung von Cookies deaktiviert.',
    use: 'Der {{appName}} erfordert die Verwendung von Cookies, um Ihnen das beste Erlebnis zu bieten.',
    details: 'Wofür werden die Cookies verwendet?',
    enable: 'So aktivieren Sie Ihre Cookies {{hier}}.',
    here: 'hier',
  },
  notLoggedIn: {
    super: 'Sie sind nicht eingeloggt',
    title: 'Sie müssen eingeloggt sein, um diesen Inhalt anzuzeigen',
    guest: 'Gast',
  },
  demo: {
    message:
      'Diese Website ist eine Demo des Endprodukts. Sie befindet sich derzeit in der Entwicklung und ist kein vollständiges Produkt.',
    consent: 'Verstanden!',
  },
  share: {
    header: 'Teilen Sie diese Ressource in Ihren bevorzugten sozialen Medien!',
    download: 'Herunterladen',
  },
  sharing: {
    copyURL: 'Link kopieren',
    copied: 'Kopiert',
  },
  breadCrumbs: {
    page: 'Seite',
  },
  onMobile: {
    header:
      'Es sieht so aus, als ob Sie versuchen, auf die {appName}-App von einem mobilen Gerät aus zuzugreifen',
    body: 'Um dieses Programm herunterzuladen, besuchen Sie einfach Ihren App-Store und suchen Sie nach {appName} oder klicken Sie auf eine der folgenden Schaltflächen',
    benefits: {
      header: 'Dadurch erhalten Sie:',
      1: 'Abschlusszertifikat',
      2: 'Kostenlose, hochwertige Marketingmaterialien',
      3: 'Berechtigung zur Teilnahme an Destination FAMS',
      4: 'Hochwirksame Vertriebsinformationen und Ressourcen',
      5: 'Zugang zur mobilen Sales Companion App',
      6: 'Verkaufstipps',
    },
  },
  custom: {
    splitUsers: 'Ich bin ein/eine ...',
    brandAmbassador: 'Markenbotschafter/in',
    travelPro: 'Reiseprofi',
  },
  rewards: {
    menu: {
      home: 'Belohnungen\nStartseite',
      achievements: 'Schulung\nErfolge',
      bookings: 'Abzeichen\nAnreize',
      form: 'Buchungen\nEinreichen',
    },
    rewards: 'Prämien',
    title: 'Willkommen im Rewards & Achievements Center',
    subheader:
      'Hier kannst du deine Trainings-Erfolge im Auge behalten und teilen.',
    button: 'Buchung einreichen',
    viewAllBookings: 'Buchungen',
    viewDashboard: 'Punkte-Dashboard',
    viewRewards: 'Überblick',
    overview: {
      valid:
        '* Die eingereichten Buchungen sind erst nach Abschluss der Kundenreise gültig.',
    },
    home: {
      entries: 'Aktuelle Einträge',
      trainingAchievements: 'TRAININGS-ERFOLGE',
      trainingAchievementsText:
        'Behalte deinen Übungsfortschritt, deine Zertifizierungen und deinen Status im Blick. Außerdem kannst du hier deine Auszeichnung als USA-Experte sowie alle erworbenen Abzeichen für Erlebnisse und Partnerspezialisierungen herunterladen und teilen.',
      bookingContests: 'INCENTIVES-DASHBOARD',
      bookingContestsText:
        'Über das Incentives-Dashboard lassen sich aktuelle Incentive-Programme bequem verfolgen und verwalten. ',
      submitBooking: 'BUCHUNGEN EINREICHEN',
      submitBookingText:
        'Hier reichst du Buchungen ein, die du auf Buchungs-Incentives anrechnen lassen willst.',
      currentContest: 'AKTUELLE INCENTIVES',
      noContests: 'Aktuell gibt es keine Incentives für Abzeichen.',
      contestTerms: 'Nutzungsbedingungen',
      noContest: 'Der Wettbewerb ist derzeit nicht verfügbar.',
    },
    bookingsView: {
      title: 'Buchungen',
      infoMessage:
        'Sortieren Sie mit den Schaltflächen oben und klicken Sie auf einen beliebigen Datensatz, um die Anmeldedetails zu verwalten. Alle ausstehenden Einträge werden innerhalb von 72 Stunden überprüft.',
    },
    leaderboardScreen: {
      prizes: 'Preise',
      tAndC: 'Es gelten die Geschäftsbedingungen.*',
    },
    dashboardView: {
      title: 'Incentives-Dashboard',
      subtitle: 'Verfolge alle deine Aktivitäten zu Incentives.',
      badge: 'Incentives für Abzeichen',
      activity: 'Incentives für Buchungen',
      manage: 'Buchungen verwalten',
      manageSub:
        'Verfolgen Sie unten die aktuellen Buchungen, oder sehen Sie sich die archivierten Buchungen an, indem Sie das Dropdown-Menü verwenden.',
      noBadgeIncentives: 'Aktuell gibt es keine Incentives für Abzeichen.',
      noBookings: 'Es liegen keine Daten vor.',
      state: {
        approvedEntries: 'Genehmigte Einträge',
        pendingEntries: 'Ausstehende Einträge',
        declinedEntries: 'Abgelehnte Einträge',
        viewAll: 'Alle Anzeigen',
      },
      currentYear: 'Laufendes Jahr',
      archivedBookings: 'Archivierte Buchungen',
    },
    bookingForm: {
      title: 'Buchungsübermittlungsformular',
      subTitle: 'Geben Sie Ihre Buchung ein:',
      required: '* Zeigt ein Pflichtfeld an',
      email: 'Agenten-E-Mail',
      agentFirstName: 'Vorname des Agenten',
      agentLastName: 'Nachname des Agenten',
      company: 'Firmenname',
      iata: 'IATA/CLIA #',
      stateProvince: 'Bundesland/Provinz',
      postalCode: 'Postleitzahl *',
      country: 'Land',
      bookingNumber: 'Buchungsbestätigungsnummer',
      numberOfGuests: 'Anzahl der erwachsenen Gäste',
      bookingDate: 'Buchungsdatum',
      tourOperator: 'Großhändler',
      firstName: 'Vorname',
      lastName: 'Nachname des Kunden',
      accommodation: 'Hotelname',
      guests: 'Anzahl der Passagiere',
      select: 'Wählen Sie eine Option',
      wholesaler: 'Großhändler',
      arrivalDate: 'Check-in-Datum',
      departureDate: 'Check-out-Datum',
      lengthOfStay: 'Aufenthaltsdauer (in Nächten)',
      reservationNumber: 'Hotelbestätigungsnummer',
      rooms: 'Anzahl der Zimmer',
      stay: 'Aufenthaltsdauer (in Nächten)',
      airline: 'Fluggesellschaft / Anbieter (2-stelliger Code)',
      originAirport: 'Abflughafen (3-Buchstaben-Code)',
      destination: 'Ziel / Insel (3-Buchstaben-Code)',
      cost: 'Gesamtkosten der Buchung (nur Dezimalzahlen verwenden)',
      file: 'RezSnap™ Nachweis-Upload',
      disclaimer: '* Pflichtfelder',
      button: 'Buchung absenden',
      sub: 'Ihre Informationen',
      sub2: 'Buchungsinformationen',
      propertyCharterCompany: 'Eigentum / Chartergesellschaft',
      flightNumber: 'Flugnummer',
      bookingType: 'Buchungstyp',
      group: 'Gruppe',
      fit: 'FIT',
    },
    TermsAndConditions: {
      title: 'Terms and Conditions',
      subTitle: 'Bahamas Specialist Quarterly Rewards',
      body1:
        'All posting must be accompanied by a zero-balance proof of sale document that corresponds with each individual booking that you have posted. Awardees will be selected based on the totality of verified proof of sale documents corresponding with each listed booking. Postings must follow all Bahamas Specialist Rewards rules for eligibility. Awards are not transferable and must be redeemed within three (3) months of award notification. Any unused, unclaimed or declined awards will be forfeited. Awards will be issued quarterly, and eligibility will be verified based on completed travel.',
      body2:
        'To be eligible you must reside in the U.S or Canada, and be age of majority or older in the state, province, or territory of residence. Tour Operator employees are NOT eligible for drawings, and will NOT be considered for additional prizes. Residents of the Province of Quebec are NOT eligible for drawings, and will NOT be considered for additional prizes.',
      body3:
        'Reward issuance may require proof of accreditation as a retail/home-based travel counselor. Available rewards are subject to change during the course of the program.',
      body4: 'Privacy and Use of Personal Information',
      body5:
        'Participating agents (i) grants to the Rewarder the right to use his/her name, city, state, province, postal code, age of majority confirmation, telephone number and e-mail address for including but not limited to contacting and announcing the Awardees and provision of awards; (ii) grants to the Awardee the right to use his/her personal information for publicity and promotional purposes relating to the awards, in any and all media now known or hereafter devised, without further compensation unless prohibited by law; and (iii) acknowledges that the Awardees may disclose his/her personal information to third-party agents and service providers in connection with any of the activities listed in (i) and (ii) above.',
      button: 'Zurück',
    },
    thankYouPage: {
      thanks: 'Vielen Dank',
      congrats: 'Glückwunsch, ',
      body: 'deine Buchung ist eingegangen und wurde zur Verifizierung an die für die Kampagnenaufsicht zuständige Stelle weitergeleitet.',
      link: 'Um als Gewinner infrage zu kommen, musst du das Grundlagen-Training aus dem USA Discovery Program absolviert haben.',
    },
  },
  search: {
    pages: 'Seiten',
    resources: 'Ressourcen',
  },
};
